import React from "react";
import { makeStyles } from "@mui/styles"; // Utilisation de la bonne importation pour MUI v5
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { FormControlLabel, RadioGroup, Radio } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 1,
    width: "100%",
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 40,
    padding: "10px 0",
  },
  checkboxes: {
    display: "block",
  },
}));

const AdminPickAndSelectMenu = (props) => {
  const {
    menus,
    menu,
    onChange,
    disabledButton,
    onCancelAction,
    onSubmit,
    submitting,
  } = props;

  const classes = useStyles();

  return (
    <div>
      <InputLabel shrink htmlFor="select-multiple-native">
        Sélectionnez le menu que vous souhaitez affecter au point de vente.
      </InputLabel>

      <RadioGroup
        aria-label="menu"
        name="menu1"
        value={menu}
        onChange={onChange}
      >
        {menus.map((menu) => (
          <FormControlLabel
            key={menu.id}
            value={menu.id}
            control={<Radio />}
            label={menu.name}
          />
        ))}
      </RadioGroup>

      <FormControl className={classes.formControl}>
        <div className={classes.actions}>
          <Button
            variant="contained"
            disabled={disabledButton || submitting}
            onClick={onSubmit}
          >
            {submitting ? "processing ..." : "Sauver"}
          </Button>
          <Button variant="contained" onClick={onCancelAction}>
            Annuler
          </Button>
        </div>
      </FormControl>
    </div>
  );
};

export default AdminPickAndSelectMenu;
